module.exports = __webpack_public_path__ + "static/media/FAVORITOS_ALT.21079952.svg";